// src/App.jsx
import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { ProfilesProvider } from "./context/ProfilesContext";

import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Main from "./components/Main";
import Loader from "./components/Loader";
import BreakpointDebugger from "./components/BreakpointDebugger";
import ErrorBoundary from "./components/ErrorBoundary";
import useAnalytics from "./hooks/useAnalytics";

import getTheme from "./styles/theme";

function Analytics() {
  useAnalytics();
  return null;
}

function App() {
  const theme = getTheme(); // ✅ This calls the function
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAppData = async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 1500));
      } catch (err) {
        console.error("Error loading app data:", err);
      } finally {
        setLoading(false);
      }
    };

    loadAppData();
  }, []);

  if (loading) return <Loader message="Loading Noor-un-Nikah..." />;

  return (
    <ThemeProvider theme={theme}> {/* ✅ Passes the theme object */}
      <ErrorBoundary>
        <ProfilesProvider>
          <Router>
            <Analytics />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                backgroundColor: "var(--background-color)",
              }}
            >
              <Header />
              <Main />
              <Footer />
            </div>
            <div
              style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                zIndex: 1000,
              }}
            >
              <WhatsAppButton />
            </div>
            <BreakpointDebugger />
          </Router>
        </ProfilesProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;